// skeleton/app/src/app/survey-url/survey-url.service.ts

import { Injectable } from '@angular/core';
import { StorageService } from '../shared/services/token-storage.service';

@Injectable({
  providedIn: 'root'
})
export class SurveyUrlService {

  constructor(private storage: StorageService) {}

  getToken() {
    const token = this.storage.get("AnonymousId");

    if (token === null || token === undefined) {
      return "";
    }

    return token;
  }

  isTokenValid(): boolean {
    // Fixed bug: must call function
    if (this.getToken() === null || this.getToken() === undefined || this.getToken() === "") {
      return false;
    }

    return true;

    /*
    // Future JWT validation logic if needed
    let split = atob(this.storage.get("AnonymousID").split('.')[1]);
    let expiry = JSON.parse(split).exp;
    let expiryDate = new Date(1000 * expiry);
    let currentDate = new Date();

    if (expiryDate > currentDate) {
      return true;
    } else {
      return false;
    }
    */
  }

  removeToken() {
    return this.storage.remove("token");
  }
}
